import { Button, Grid, Typography } from "@mui/material";
import { SectionHeading } from "~/components/DetailsPage/components";
import { Flex } from "~/components/Flex";
import { Text } from "~/components/ui-library";
import { Mquery, MqueryVariant } from "~/operations";
import { CheckQueriesPropertyItems } from "./components/CheckQueriesPropertyItems";
import { CheckQueriesMql } from "./components/CheckQueriesMql";
import { Link as RouterLink } from "react-router-dom";
import { ArrowForward as ArrowForwardIcon } from "@mui/icons-material";
import { useScope } from "~/hooks/useScope";
import { getPolicyPropertiesTabUrl } from "~/lib/urlUtils";

type CheckQueriesProps = {
  properties?: Mquery["properties"] | MqueryVariant["properties"] | null;
  mql?: Mquery["mql"] | MqueryVariant["mql"] | null;
  policyId?: string;
};

export const CheckQueries = ({
  properties,
  mql,
  policyId,
}: CheckQueriesProps) => {
  const { spaceScope } = useScope();
  const linkToPolicyPropertiesTab = getPolicyPropertiesTabUrl({
    policyId,
    spaceId: spaceScope?.id,
  });

  return (
    <Grid container size={12}>
      <Grid size={12}>
        <SectionHeading heading="Queries" />
      </Grid>

      {(properties?.length || 0) > 0 && (
        <Grid size={12} mb={4}>
          <Flex justifyContent="space-between" flexDirection="column" mb={2}>
            <Flex
              sx={{
                textTransform: "uppercase",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Text bold>PROPERTIES</Text>
              <Button
                component={RouterLink}
                to={linkToPolicyPropertiesTab}
                endIcon={<ArrowForwardIcon />}
                sx={{
                  color: "secondary.light",
                }}
              >
                Edit Properties
              </Button>
            </Flex>
            <Typography sx={{ color: "text.secondary" }}>
              Different access keys and secrets are defined here to ensure each
              supported technology provided with the policy is configured
              correctly.
            </Typography>
          </Flex>
          <CheckQueriesPropertyItems {...{ properties }} />
        </Grid>
      )}

      {mql && (
        <Grid size={12}>
          <Flex justifyContent="space-between" flexDirection="column">
            <Text bold sx={{ textTransform: "uppercase" }}>
              MQL Queries
            </Text>
          </Flex>
          <CheckQueriesMql {...{ mql }} />
        </Grid>
      )}
    </Grid>
  );
};
